/* eslint-disable radix */
import React, { useState, useEffect, useRef } from 'react'
import {
  Div, H4,
} from 'konsys-ui'
import { StickyContainer, Sticky } from 'react-sticky'
import {
  NumberLabel,
  ContentTabPane,
  Tabs,
  TrapezoidTab,
} from './styled'


const { TabPane } = Tabs

const renderTabBar = (props, DefaultTabBar, sticky) => {
  if (sticky) {
    return (
      <Sticky topOffset={0} bottomOffset={20}>
      {
        ({ style }) => (<Div>
          <DefaultTabBar {...props} style={{ ...style, zIndex: 1 }} />
        </Div>
        )
      }
    </Sticky>
    )
  }
  return (
    <Div>
      <DefaultTabBar
        {...props} style={{
          borderBottom: '0px',
          height: '40px',
        }}
      />
    </Div>
  )
}

const TabPart = ({
  onChange,
  data,
  children,
  activeTab,
  handleChangeTap,
  sticky,
  ContentRef,
  isOne,
}) => {
  const [tabPanes, setTabPanes] = useState([
    { name: '1', key: 0, content: 'content 1' },
    { name: '2', key: 1, content: 'content 2' },
    { name: '3', key: 2, content: 'content 3' },
  ])
  const ContentTab = useRef(null)

  useEffect(() => {
    if (data) {
      setTabPanes(data)
    }
  }, [data])
  const [top, setTop] = useState(0)
  useEffect(() => {
    const scrollFun = () => {
      if (sticky) {
        let extraHeight = 209
        if (isOne) {
          extraHeight = 109
        }
        const bottom = ContentRef.current.offsetTop + ContentRef.current.offsetHeight - (ContentTab.current.offsetHeight + extraHeight)
        if (window.pageYOffset > ContentRef.current.offsetTop && window.pageYOffset < bottom) {
          setTop(window.pageYOffset - ContentRef.current.offsetTop)
        } else if (window.pageYOffset >= bottom) {
          setTop(bottom - ContentRef.current.offsetTop)
        } else {
          setTop(0)
        }
      }
    }

    window.addEventListener('scroll', scrollFun)

    return () => {
      window.removeEventListener('scroll', scrollFun)
    }
  }, [])

  if (sticky) {
    return (
      <StickyContainer style={{ height: '100%', overflow: 'visible' }}>
        <div
        ref={ContentTab}
        style={{
          width: '100%',
          position: 'absolute',
          top,
          transition: 'all 0.2s linear',
        }}>
          <Tabs
            defaultActiveKey={activeTab}
            activeKey={activeTab.toString()}
            onChange={handleChangeTap}
            renderTabBar={renderTabBar}
            onTabClick={handleChangeTap}
            animated={false}
          >
            {
              tabPanes.map((tab, index) => (
                <TabPane
                  style={{ background: 'white' }}
                  tab={
                    <TrapezoidTab>
                      <CustomTab name={index + 1} activeTab={parseInt(activeTab) === parseInt(index)} />
                    </TrapezoidTab>
                  }
                  key={index}
                >
                  <ContentTabPane>
                    {children}
                  </ContentTabPane>
                </TabPane>
              ))
            }
          </Tabs>
        </div>
      </StickyContainer>
    )
  }
  return (
    <Div>
      <Tabs
          defaultActiveKey={activeTab}
          activeKey={activeTab.toString()}
          onChange={handleChangeTap}
          renderTabBar={(props, DefaultTabBar) => renderTabBar(props, DefaultTabBar, sticky)}
          onTabClick={handleChangeTap}
          animated={false}
        >
          {
            tabPanes.map((tab, index) => (
              <TabPane
                style={{ background: 'white' }}
                tab={
                  <TrapezoidTab>
                    <CustomTab name={index + 1} activeTab={parseInt(activeTab) === parseInt(index)} />
                  </TrapezoidTab>
                }
                key={index}
              >
                <ContentTabPane>
                  {children}
                </ContentTabPane>
              </TabPane>
            ))
          }
        </Tabs>
    </Div>
  )
}

const CustomTab = ({ name, activeTab }) => (
  <div className={`tab ${activeTab ? 'tab-active' : 'tab-inactive'}`}>
    <div className={`label ${activeTab ? 'label-active' : 'label-inactive'}`}>
      <div className={activeTab ? 'circle-number-active' : 'circle-number'}>
        {name}
      </div>
    </div>
  </div>
)

export default TabPart



// WEBPACK FOOTER //
// ./src/components/common/tab-summary/index.jsx